import { useSearchParams } from 'react-router-dom';

export default function useIsKioskMode() {
  const [searchParams] = useSearchParams();
  return searchParams.get('kiosk') === 'true';
}
